import { t } from 'i18next';
import * as Icons from '@mui/icons-material';
import { BakeasyButton, BakeasyButtonProps } from './BakeasyButton';
import { BakeasyButtonIcon, BakeasyButtonIconProps } from './BakeasyIconButton';
import { ArrowBack } from '@mui/icons-material';

export function Export(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('EXPORT')} startIcon={<Icons.FileDownload />} />;
}

export function Filter(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('FILTER')} startIcon={<Icons.FilterAltOutlined />} />;
}

export function Add(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('ADD')} startIcon={<Icons.Add />} />;
}

export function Create(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('CREATE')} />;
}

export function Cancel(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('CANCEL')} variant={'outlined'} />;
}

export function NewMsg(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('NEW_MESSAGE')} startIcon={<Icons.Create />} />;
}

export function Update(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('UPDATE')} />;
}

export function Print(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('PRINT')} startIcon={<Icons.Print />} />;
}

export function Edit(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('EDIT')} startIcon={<Icons.Edit />} />;
}

export function Send(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('SEND')} startIcon={<Icons.Send />} />;
}

export function Clear(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('CLEAR')} />;
}

export function SaveToCart(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('SAVE_TO_CART')} />;
}

export function CreateOrder(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('CREATE_ORDER')} />;
}

export function GoToOrderDetails(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('GO_BACK_TO_ORDER_DETAILS')} />;
}

export function SendOrder(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('SEND_ORDER')} color={'warning'} />;
}

export function Cart(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('CART')} size={'small'} />;
}

export function GoToOrderForm(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('GoToOrderForm')} />;
}

export function Upload(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('UPLOAD')} startIcon={<Icons.FileUpload />} />;
}

export function BakeasyButtonIconBack(props: BakeasyButtonIconProps) {
  return <BakeasyButtonIcon {...props} color="default" icon={<ArrowBack />} />;
}

export function CancelDelete(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('CANCEL_DELETE')} variant={'outlined'} />;
}
